'use client';
var classes = {"root":"m_4451eb3a"};

export { classes as default };
//# sourceMappingURL=Center.module.css.mjs.map
